import React from 'react';
import PageTabs from '@app/component/tabs/PageTabs';
import { useSelectedCompanyHotel } from '@app/site/secured/rateshopper/rates/provider/useSelectedCompanyHotel';

const PricingAutomationDashboardPage = React.memo(() => {

	const {companyHotel} = useSelectedCompanyHotel();

	return <main>
		<div className="mx-auto max-w-7xl py-6 px-4 sm:px-6 lg:px-8">
			<div className="mt-6">
				<PageTabs options={[
					{
						label: 'Room Anchoring',
						link: '/secured/rateshopper/rates/pricing-automation',
					},
					{
						label: 'Competitors Importance',
						link: '/secured/rateshopper/rates/pricing-automation/competitors-importance',
						match: '/secured/rateshopper/rates/pricing-automation/competitors-importance',
						disabled: !companyHotel.hasPriceRecommendationModule()
					},
					{
						label: 'Price Submission Log',
						link: '/secured/rateshopper/rates/pricing-automation/price-submission-log',
						match: '/secured/rateshopper/rates/pricing-automation/price-submission-log',
					},
				]} isOutlet />
			</div>
		</div>
	</main>
});

export default PricingAutomationDashboardPage;